import Icon from 'src/components/ui/Icon'

type ShelfBoughtTogetherFooterProps = {
  onDeleteCard: () => void
  onReloadCard: () => void
}

export default function ShelfBoughtTogetherFooter({
  onDeleteCard,
  onReloadCard,
}: ShelfBoughtTogetherFooterProps) {
  return (
    <footer className="mt-1 flex items-center justify-center gap-x-4">
      <button aria-label="Close" name="Close" onClick={() => onDeleteCard()}>
        <Icon name="Close" width={20} height={20} fill="#007cb9" />
      </button>
      <button aria-label="Reload" name="Reload" onClick={() => onReloadCard()}>
        <Icon name="Reload" width={16} height={17} />
      </button>
    </footer>
  )
}
